export default "__VITE_ASSET__bQ0QPBxw__"